export default "__VITE_ASSET__ClAjXaek__"